<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="经销商名称"
        v-model="listQuery.name"
      ></el-input>
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="经销商编号"
        v-model="listQuery.code"
      ></el-input>
      <el-cascader
        class="filter-item"
        style="width: 350px"
        placeholder="选择经销商"
        filterable
        change-on-select
        :show-all-levels="false"
        :options="dealerOptions"
        v-model="listQuery.dealerCode"
      ></el-cascader>

      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.status"
      >
        <el-option label="全部状态" :value="99"></el-option>
        <el-option label="正常" :value="0"></el-option>
        <el-option label="冻结" :value="-1"></el-option>
      </el-select>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.joinStatus"
      >
        <el-option label="注册状态" :value="99"></el-option>
        <el-option label="已注册" :value="1"></el-option>
        <el-option label="未注册" :value="0"></el-option>
      </el-select>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-if="businessType === 0"
        v-model="listQuery.type"
      >
        <el-option label="商家类型" :value="99"></el-option>
        <el-option label="对公" :value="6"></el-option>
      </el-select>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.allSeries"
      >
        <el-option label="全部车系" :value="99"></el-option>
        <el-option label="关闭" :value="0"></el-option>
        <el-option label="开启" :value="1"></el-option>
      </el-select>
      <el-select
        style="width: 200px"
        multiple
        class="filter-item"
        v-model="listQuery.salesLevel"
        placeholder="等级"
      >
        <el-option
          v-for="item in salesLevels"
          :key="item.dataName"
          :label="item.dataName"
          :value="item.dataName"
        ></el-option>
      </el-select>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.allowCrossGroup"
        placeholder="跨集团贡献线索"
      >
        <el-option label="是" :value="1"></el-option>
        <el-option label="否" :value="2"></el-option>
      </el-select>

      <el-button
        class="filter-item"
        type="info"
        icon="el-icon-search"
        @click="doSearch"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="doReset"
        >重置</el-button
      >
      <!-- <el-button class="filter-item" @click="showImportDialog"
        >经销商导入</el-button
      >
      <el-button class="filter-item" @click="showSyncDialog"
        >渠道同步</el-button
      > -->
      <el-button class="filter-item" icon="el-icon-download" @click="doExport"
        >导出经销商</el-button
      >
      <!-- <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="doExportMapping"
        >导出映射</el-button
      > -->
      <!-- <el-button class="filter-item" type="primary" icon="el-icon-plus" @click='showAddDialog'>添加</el-button> -->
    </div>
    <el-table
      :data="list"
      v-loading="listLoading"
      border
      fit
      highlight-current-row
      style="width: 100%"
      max-height="600"
    >
      <el-table-column align="left" label="编号" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.code }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="经销商名称" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="网络编码" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.mainNetworkCode }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="主网络" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.mainNetworkName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="是否注册" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.joined ? "已注册" : "未注册" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="商家类型" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.type | dealerTypeDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="社会/自营" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.dealerType }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="等级" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.level }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="跨集团贡献线索" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.allowCrossGroup == 1 ? "是" : "否" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="地址" width="300">
        <template slot-scope="scope">
          <span>{{
            scope.row.salesCenter +
            "/" +
            scope.row.bigArea +
            "/" +
            scope.row.area +
            "/" +
            scope.row.province +
            "/" +
            scope.row.city
          }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="展业城市" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.dealerCities }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="策略" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.online | onlineDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="城市类别" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.cityType }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="left"
                       label="提交日报"
                       width="100">
        <template slot-scope="scope">
          <span>{{scope.row.dailyReport | dailyReportDisplay}}</span>
        </template>
      </el-table-column> -->
      <el-table-column align="left" label="全部车系" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.allSeries ? "开启" : "关闭" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="线上线索" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.onlineOrder | onlineOrderDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="人员" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.memberCount }}</span>
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        align="center"
        label="状态"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{
            scope.row.status | statusDisplay
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditDialog(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button size="mini" @click="showOnlineDialog(scope.row)"
            >映射</el-button
          > -->
          <!-- <el-button  size="mini" @click="showSeriesDialog(scope.row)">车系</el-button> -->
          <!-- <el-button type="warning" circle size="mini" icon="el-icon-delete" @click="toDelete(scope.row.id)"></el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="经销商导入"
      :visible.sync="importDialogVisible"
      width="30%"
    >
      <div style="text-align: center">
        <el-upload
          class="upload-demo"
          accept=".xlsx"
          drag
          action
          :file-list="uploadFiles"
          :http-request="uploadRequest"
          :limit="1"
          :on-success="uploadSuccess"
          :on-remove="uploadRemove"
          :before-upload="uploadBefore"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
        </el-upload>
        <div>
          <a
            href="https://duigongzhizhu-oss-test.oss-cn-shenzhen.aliyuncs.com/public/%E5%AF%B9%E5%85%AC%E7%BB%8F%E9%94%80%E5%95%86%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
            class="table-href"
            >下载模版</a
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideImportDialog">取消</el-button>
        <el-button type="primary" :loading="uploadLoading" @click="doImport"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="渠道同步" :visible.sync="syncDialogVisible" width="35%">
      <el-form label-position="right" label-width="120px">
        <el-form-item label="选择渠道">
          <el-select v-model="importSource" placeholder="请选择">
            <el-option
              v-for="item in importSources"
              :key="item.dataName"
              :label="item.dataDisplay"
              :value="item.dataName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            accept=".xlsx"
            drag
            action
            :file-list="uploadFiles"
            :http-request="uploadRequest"
            :limit="1"
            :on-success="uploadSuccess"
            :on-remove="uploadRemove"
            :before-upload="uploadBefore"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
          </el-upload>
          <div>
            <a
              href="https://cxs1.oss-cn-shenzhen.aliyuncs.com/template/byd/%E7%BB%8F%E9%94%80%E5%95%86%E6%B8%A0%E9%81%93ID%E6%98%A0%E5%B0%84%E6%A8%A1%E7%89%88.xlsx"
              class="table-href"
              >下载模版</a
            >
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="hideImportDialog">取消</el-button>
        <el-button type="primary" :loading="syncLoading" @click="doSync"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="编辑数据" :visible.sync="editDialogVisible" width="60%">
      <el-form
        ref="editForm"
        :model="editData"
        label-position="right"
        label-width="150px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="经销商编号">
              <el-input
                clearable
                style="width: 200px"
                class="filter-item"
                placeholder="请输入编号"
                v-model="editData.code"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="城市类别">
              <el-col :span="8">
                <el-select
                  style="width: 200px"
                  disabled
                  class="filter-item"
                  v-model="editData.cityType"
                >
                  <el-option label="一类" value="一类"></el-option>
                  <el-option label="二类" value="二类"></el-option>
                  <el-option label="三类" value="三类"></el-option>
                  <el-option label="四类" value="四类"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经销商名称">
              <el-input
                clearable
                style="width: 200px"
                class="filter-item"
                placeholder="请输入名称"
                v-model="editData.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="businessType === 0">
            <el-form-item label="商家类型">
              <el-col :span="8">
                <el-select
                  style="width: 200px"
                  class="filter-item"
                  v-model="editData.type"
                >
                  <el-option label="对公" :value="6"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商家类型">{{
              editData.dealerType
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="线上线索">
              <el-col :span="8">
                <el-select
                  style="width: 200px"
                  class="filter-item"
                  v-model="editData.onlineOrder"
                >
                  <el-option label="开放" :value="true"></el-option>
                  <el-option label="限制" :value="false"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="地址">{{
              editData.salesCenter +
              "/" +
              editData.bigArea +
              "/" +
              editData.province +
              "/" +
              editData.city
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="全部车系">
              <el-col :span="8">
                <el-select
                  style="width: 200px"
                  class="filter-item"
                  v-model="editData.allSeries"
                >
                  <el-option label="开启" :value="true"></el-option>
                  <el-option label="关闭" :value="false"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="是否注册">{{
              editData.joined ? "已注册" : "未注册"
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select
                style="width: 200px"
                class="filter-item"
                v-model="editData.status"
              >
                <el-option label="正常" :value="0"></el-option>
                <el-option label="冻结" :value="-1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="等级">{{ editData.level }}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="邮箱">{{ editData.email }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-show="
            editData.level == '展厅店' ||
            editData.level == '体验店' ||
            editData.level == '专营店'
          "
        >
          <el-col :span="24">
            <el-form-item label="经销商名称(一级)">{{
              editData.topDealerName
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-show="
            editData.level == '展厅店' ||
            editData.level == '体验店' ||
            editData.level == '专营店'
          "
        >
          <el-col :span="24">
            <el-form-item label="经销商编码(一级)">{{
              editData.topDealerCode
            }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdate">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="映射设置"
      :visible.sync="onlineDialogVisible"
      width="40%;"
      class="dialog-set"
    >
      <el-form
        ref="editForm"
        :model="editData"
        label-position="right"
        label-width="150px"
      >
        <el-form-item label="经销商编号">{{ editData.code }}</el-form-item>
        <el-form-item label="经销商名称">{{ editData.name }}</el-form-item>
        <el-form-item
          v-for="(item, index) in editData.onlines"
          :key="index"
          :label="item.name"
        >
          <el-input
            style="width: 100px"
            v-model="item.code"
            placeholder="映射编号"
          ></el-input>
          <!-- <el-input style="width: 200px" v-model="item.mapName" placeholder="映射名称"></el-input> -->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onlineDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdateOnlines">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="车系设置" :visible.sync="seriesDialogVisible" width="40%">
      <el-checkbox-group v-model="series">
        <el-checkbox
          style="margin-left: 20px; margin-bottom: 10px"
          v-for="item in seriesRecords"
          :label="item.code"
          :key="item.code"
          >{{ item.name }}</el-checkbox
        >
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="seriesDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doSaveSeries">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";
import oss from "@/utils/ali-oss";

export default {
  name: "DealerList",
  data() {
    return {
      businessType: store.getters.user.businessType,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        salesCenter: "",
        bigArea: "",
        name: "",
        code: "",
        salesLevel: [],
        status: 99,
        joinStatus: 99,
        dealerCode: [],
        type: 99,
        allSeries: 99,
        dailyReport: 99,
        cityType: "",
      },
      salesLevels: [
        { dataName: "4S" },
        { dataName: "4S(A)" },
        { dataName: "4S(B)" },
        { dataName: "专营店" },
        { dataName: "体验中心" },
        { dataName: "商超" },
        { dataName: "商超店" },
        { dataName: "城市体验店" },
        { dataName: "城市展厅" },
        { dataName: "销售展厅" },
      ],
      roles: [],

      editDialogVisible: false,
      editData: {},

      salesCenters: [],
      importSources: [],

      importDialogVisible: false,
      uploadFiles: [],
      uploadFile: "",
      uploadLoading: false,

      onlineDialogVisible: false,

      syncDialogVisible: false,
      importSource: "",
      syncLoading: false,

      seriesRecords: [],

      seriesDialogVisible: false,

      series: [],
      dealerOptions: [],
    };
  },
  filters: {
    dealerTypeDisplay(type) {
      const map = {
        1: "王朝",
        2: "海洋",
        6: "对公",
      };
      return map[type];
    },
    statusFilter(status) {
      const statusMap = {
        0: "success",
        1: "info",
      };
      return statusMap[status];
    },
    onlineDisplay(online) {
      const statusMap = {
        0: "",
        1: "BDC清洗，主管分配",
        2: "BDC清洗，BDC分配",
        3: "无BDC清洗，自动分配",
      };
      return statusMap[online];
    },
    statusDisplay(status) {
      const statusMap = {
        0: "正常",
        "-1": "冻结",
      };
      return statusMap[status];
    },
    dailyReportDisplay(flag) {
      const map = {
        true: "允许",
        false: "关闭",
      };
      return map[flag];
    },
    onlineOrderDisplay(flag) {
      const map = {
        true: "开放",
        false: "限制",
      };
      return map[flag];
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  activated() {
    if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
      this.doReset();
      this.$route.meta.redraw = false;
    }
    if (
      this.$route.meta.hasOwnProperty("refresh") &&
      this.$route.meta.refresh
    ) {
      this.getList();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    this.doReset();
    this.retrieveSystemData();
    this.retrieveSeries();
    this.retrieveDealerOptions();
  },
  methods: {
    doReset() {
      this.list = [];
      this.total = 0;
      this.listLoading = true;
      this.listQuery = {
        page: 1,
        limit: 10,
        salesCenter: "",
        bigArea: "",
        name: "",
        code: "",
        salesLevel: [],
        status: 99,
        joinStatus: 99,
        dealerCode: [],
        type: 99,
        allSeries: 99,
        dailyReport: 99,
        cityType: "",
        allowCrossGroup: null, // 1是 2否
      };
      this.doSearch();
    },
    retrieveDealerOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/jsonTree", {})
        .then(function (response) {
          parent.dealerOptions = response.data.data;
          parent.dealerOptions.unshift({
            label: "全部",
            level: 1,
            value: "",
          });
        });
    },
    retrieveSeries() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/seriesList", {
          pageStart: 0,
          pageCount: 1000,
          status: 0,
          useMap: false,
          needReport: 99,
          category: 99,
        })
        .then(function (response) {
          parent.seriesRecords = response.data.data;
        });
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    retrieveSystemData() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDictionaryRpc/getDictionaries", {
          category: "BACKEND_SALES_CENTER",
        })
        .then(function (response) {
          parent.salesCenters = response.data.data;
        });
      this.$httpAuth
        .post("/v1/backendDictionaryRpc/getDictionaries", {
          category: "IMPORT_SOURCE",
        })
        .then(function (response) {
          parent.importSources = response.data.data;
        });
    },
    getList() {
      this.listLoading = true;
      var parent = this;
      var dealerCode = "";
      var dealerBigArea = "";
      var dealerSalesCenter = "";
      var dealerProvince = "";
      var dealerCity = "";
      if (this.listQuery.dealerCode.length == 5) {
        dealerCode = this.listQuery.dealerCode[4];
      }
      if (this.listQuery.dealerCode.length == 1) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
      }
      if (this.listQuery.dealerCode.length == 2) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
      }
      if (this.listQuery.dealerCode.length == 3) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
      }
      if (this.listQuery.dealerCode.length == 4) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
        dealerCity = this.listQuery.dealerCode[3];
      }
      this.$httpAuth
        .post("/v1/backendDealerRpc/list", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          status: this.listQuery.status,
          salesCenter: this.listQuery.salesCenter,
          bigArea: this.listQuery.bigArea,
          province: "",
          city: "",
          name: this.listQuery.name,
          level: this.listQuery.salesLevel.join(","),
          email: this.listQuery.email,
          code: this.listQuery.code,
          joinStatus: this.listQuery.joinStatus,
          dealerCode: dealerCode,
          dealerBigArea: dealerBigArea,
          dealerSalesCenter: dealerSalesCenter,
          dealerProvince: dealerProvince,
          dealerCity: dealerCity,
          type: this.listQuery.type,
          dailyReport: this.listQuery.dailyReport,
          cityType: this.listQuery.cityType,
          allSeries: this.listQuery.allSeries,
          allowCrossGroup: this.listQuery.allowCrossGroup,
        })
        .then(function (response) {
          parent.listLoading = false;
          parent.list = response.data.data;
          parent.total = response.data.total;
        })
        .catch(() => {
          parent.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    showAddDialog() {
      this.newDialogVisible = true;
      this.newData = {
        appType: "",
        deviceType: "",
        version: "",
        versionNum: 1,
        isForce: false,
        url: "",
        content: "",
        type: 1,
      };
      if (this.$refs["newForm"]) {
        this.$refs["newForm"].resetFields();
      }
    },
    showEditDialog(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      delete this.editData.allowCrossGroup;
      this.editDialogVisible = true;
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },

    showSeriesDialog(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      if (row.series == "") {
        this.series = [];
      } else {
        this.series = row.series.split(",");
      }

      this.seriesDialogVisible = true;
    },
    doUpdate() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/update", this.editData)
        .then(function (response) {
          parent.getList();
          parent.$notify({
            title: "提示",
            message: "保存成功",
          });
          parent.editDialogVisible = false;
        });
    },
    showImportDialog() {
      this.importDialogVisible = true;
      this.uploadLoading = false;
    },

    hideImportDialog() {
      this.uploadFiles = [];
      this.uploadFile = "";
      this.importSource = "";
      this.importDialogVisible = false;
      this.syncDialogVisible = false;
    },

    uploadBefore(file) {
      if (
        file.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.$message.error("请上传xlsx格式文件!");
        return false;
      }
    },
    uploadRequest(option) {
      oss.ossUploadFile(option);
    },
    uploadSuccess(res, file) {
      this.uploadFile = res;
    },

    uploadRemove(file, fileList) {
      this.uploadFile = "";
    },

    doImport() {
      if (this.uploadFile == "") {
        this.$message({
          message: "请选择导入文件",
          type: "warning",
        });
        return;
      }
      var parent = this;
      parent.uploadLoading = true;
      this.$httpAuth
        .post("/v1/backendDealerRpc/import", {
          fileUrl: this.uploadFile,
        })
        .then(function (response) {
          parent.uploadLoading = false;
          console.log(response.data);
          parent.$notify({
            title: "经销商导入结果",
            dangerouslyUseHTMLString: true,
            message:
              "<strong>插入 <i>" +
              response.data.addedCount +
              "</i> 条经销商数据</strong>" +
              "<br>" +
              "<strong>更新 <i>" +
              response.data.updatedCount +
              "</i> 条经销商数据</strong>" +
              "<br>" +
              "<strong>失败 <i>" +
              response.data.failedCount +
              "</i> 条经销商数据</strong>",
          });
          parent.hideImportDialog();
          parent.doReset();
        })
        .catch(function (error) {
          parent.uploadLoading = false;
          return;
        });
    },

    showOnlineDialog(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      this.onlineDialogVisible = true;
    },

    doUpdateOnlines() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/updateOnline", {
          id: this.editData.id,
          onlines: this.editData.onlines,
        })
        .then(function (response) {
          console.log(response.data);
          parent.$notify({
            title: "提示",
            message: "保存成功",
          });
          parent.onlineDialogVisible = false;
          parent.getList();
        });
    },

    showSyncDialog() {
      this.syncDialogVisible = true;
      this.syncLoading = false;
    },

    doSync() {
      if (this.importSource == "") {
        this.$message({
          message: "请选择同步渠道",
          type: "warning",
        });
        return;
      }
      if (this.uploadFile == "") {
        this.$message({
          message: "请选择导入文件",
          type: "warning",
        });
        return;
      }
      var parent = this;
      parent.syncLoading = true;
      this.$httpAuth
        .post("/v1/backendDealerRpc/syncOnline", {
          identify: this.importSource,
          fileUrl: this.uploadFile,
        })
        .then(function (response) {
          console.log(response.data);
          parent.syncLoading = false;
          parent.$notify({
            title: "渠道同步结果",
            dangerouslyUseHTMLString: true,
            message:
              "<strong>已成功更新 <i>" +
              response.data.count +
              "</i> 条数据</strong>",
          });
          parent.hideImportDialog();
          parent.doReset();
        })
        .catch(function (error) {
          parent.syncLoading = false;
          return;
        });
    },
    doSaveSeries() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/updateSeries", {
          id: this.editData.id,
          codes: this.series.join(),
        })
        .then(function (response) {
          parent.getList();
          parent.$notify({
            title: "提示",
            message: "保存成功",
          });
          parent.seriesDialogVisible = false;
        });
    },
    doExport() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      var parent = this;
      var dealerCode = "";
      var dealerBigArea = "";
      var dealerSalesCenter = "";
      var dealerProvince = "";
      var dealerCity = "";
      if (this.listQuery.dealerCode.length == 5) {
        dealerCode = this.listQuery.dealerCode[4];
      }
      if (this.listQuery.dealerCode.length == 1) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
      }
      if (this.listQuery.dealerCode.length == 2) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
      }
      if (this.listQuery.dealerCode.length == 3) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
      }
      if (this.listQuery.dealerCode.length == 4) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
        dealerCity = this.listQuery.dealerCode[3];
      }
      this.$httpAuth
        .post("/v1/backendDealerRpc/list", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          status: this.listQuery.status,
          salesCenter: this.listQuery.salesCenter,
          bigArea: this.listQuery.bigArea,
          province: "",
          city: "",
          name: this.listQuery.name,
          level: this.listQuery.salesLevel.join(","),
          email: this.listQuery.email,
          code: this.listQuery.code,
          joinStatus: this.listQuery.joinStatus,
          dealerCode: dealerCode,
          dealerBigArea: dealerBigArea,
          dealerSalesCenter: dealerSalesCenter,
          dealerProvince: dealerProvince,
          dealerCity: dealerCity,
          isExport: true,
          type: this.listQuery.type,
          allSeries: this.listQuery.allSeries,
          dailyReport: this.listQuery.dailyReport,
          cityType: this.listQuery.cityType,
          allowCrossGroup: this.listQuery.allowCrossGroup,
        })
        .then(function (response) {
          setTimeout(() => {
            loading.close();
            var a = document.createElement("a");
            a.href = response.data.file;
            a.click();
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    },
    doExportMapping() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      var parent = this;
      var dealerCode = "";
      var dealerBigArea = "";
      var dealerSalesCenter = "";
      var dealerProvince = "";
      var dealerCity = "";
      if (this.listQuery.dealerCode.length == 5) {
        dealerCode = this.listQuery.dealerCode[4];
      }
      if (this.listQuery.dealerCode.length == 1) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
      }
      if (this.listQuery.dealerCode.length == 2) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
      }
      if (this.listQuery.dealerCode.length == 3) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
      }
      if (this.listQuery.dealerCode.length == 4) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
        dealerCity = this.listQuery.dealerCode[3];
      }
      this.$httpAuth
        .post("/v1/backendDealerRpc/exportMapping", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          status: this.listQuery.status,
          salesCenter: this.listQuery.salesCenter,
          bigArea: this.listQuery.bigArea,
          province: "",
          city: "",
          name: this.listQuery.name,
          level: this.listQuery.salesLevel.join(","),
          email: this.listQuery.email,
          code: this.listQuery.code,
          joinStatus: this.listQuery.joinStatus,
          dealerCode: dealerCode,
          dealerBigArea: dealerBigArea,
          dealerSalesCenter: dealerSalesCenter,
          dealerProvince: dealerProvince,
          dealerCity: dealerCity,
          type: this.listQuery.type,
          allSeries: this.listQuery.allSeries,
          dailyReport: this.listQuery.dailyReport,
          cityType: this.listQuery.cityType,
        })
        .then(function (response) {
          setTimeout(() => {
            loading.close();
            var a = document.createElement("a");
            a.href = response.data.file;
            a.click();
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 8px !important;
}
</style>

<style>
.dialog-set .el-dialog__body {
  height: 500px;
  overflow: scroll;
}
</style>
